import React from 'react';
import Header from '../../components/Header';
import { Footer } from '../../components/Footer';

export default function TermsPage() {
  const stripedBg = {
    backgroundImage: 'repeating-linear-gradient(-45deg, var(--bg-stripe), var(--bg-stripe) 2px, var(--bg-body) 2px, var(--bg-body) 10px)',
    backgroundColor: 'var(--bg-body)'
  };

  const sections = [
    { id: "1", title: "Service", text: "We provide educational resources and materials through our platform. All services are provided 'as is' and we reserve the right to modify or discontinue the service at any time without notice." },
    { id: "2", title: "User Agreement", text: "By accessing our website, you agree to be bound by these Terms of Service and our Privacy Policy. If you disagree with any part of these terms, you may not access the service." },
    { id: "3", title: "Your License", text: "We grant you a limited, non-exclusive, non-transferable license to access our courses for personal, non-commercial use. You may not share your login credentials or redistribute our content." },
    { id: "4", title: "Support Services", text: "Support is provided primarily through our community and support portal. We strive to respond to all inquiries within 24-48 business hours." },
    { id: "5", title: "Fees and Payment", text: "Subscription fees are charged at the beginning of each billing cycle. All payments are non-refundable unless specified otherwise in a specific promotion." },
    { id: "6", title: "Cancellation", text: "You can cancel your subscription at any time. Your access will continue until the end of the current paid billing period." },
    { id: "7", title: "Right to Terminate", text: "We reserve the right to terminate accounts that violate our community guidelines or attempt to scrape content from the platform." },
    { id: "8", title: "Your Responsibilities", text: "You are responsible for maintaining the security of your account and for all activities that occur under your credentials." }
  ];

  return (
    <div style={stripedBg} className="min-h-screen w-full py-2 px-2 sm:py-8 sm:px-4 md:px-8 lg:px-12 flex justify-center font-sans text-slate-900 overflow-hidden">
      
      <div className="w-full bg-[var(--bg-box)] rounded-[1.5rem] md:rounded-[2.5rem] overflow-hidden border border-[var(--border-200)] flex flex-col relative shadow-sm">
        <Header />  

        <main className="flex-grow">
          
          {/* --- MAIN CONTENT CARD --- */}
          <section className="py-10 sm:py-16 md:py-24 px-2 sm:px-4 md:px-6 flex justify-center">
            <div className="w-full max-w-4xl bg-white rounded-xl md:rounded-[2rem] border border-gray-200 p-4 sm:p-8 md:p-10 lg:p-20 shadow-sm">
              
              {/* Card Header */}
              <div className="mb-12">
              
                <h1 className="text-4xl md:text-5xl font-extrabold text-[#2b3543] tracking-tight">
                  Terms and Conditions
                </h1>
                <p className="mt-6 text-slate-500 font-medium text-lg leading-relaxed">
                  Please read these terms and conditions carefully before using our website. By accessing or using our services, you agree to be bound by these terms.
                </p>
                <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mt-4">
                  Last updated: March 2026
                </p>
              </div>

              {/* Sections List */}
              <div className="space-y-12">
                {sections.map((item) => (
                  <div key={item.id} className="border-t border-gray-100 pt-8">
                    <h2 className="text-xl font-extrabold text-[#2b3543] mb-4">
                      {item.id}. {item.title}
                    </h2>
                    <p className="text-slate-500 leading-relaxed font-medium">
                      {item.text}
                    </p>
                  </div>
                ))}
              </div>

            </div>
          </section>

        </main>

        <Footer />
      </div>
    </div>
  );
}
